import axios from 'axios';
import { getHostname } from './server/server' 

const hostname = getHostname();
const path = '/v2/event';

async function postEvent(hubId, customerId, command, payload, createNew = false) {
    const res = await axios.post(`${hostname}${path}?hubId=${hubId}`, { command, payload, createNew });
    return res.data;
}

export {
    postEvent
}